import React, { Fragment, useEffect } from "react"
import * as d3 from "d3"
import { Donut3D } from "./3DPie"
import { usingExplorer } from "../../utility/Utility"

const HEIGHT_CONST = 1.4

// const Arc = ({ data, index, createArc, colors, format }) => {
//   const DEG = 115;
//   return (

//     <g key={index} className="arc" transform={`rotate(-${DEG})`}>
//       <path className="arc" d={createArc(data)} fill={colors(index)} />
//       <text
//         transform={`translate(${createArc.centroid(data)}) rotate(${DEG})`}
//         textAnchor="middle"
//         alignmentBaseline="middle"
//         fill="white"
//         fontSize="20"
//       >
//         {format(data.value)}%
//       </text>
//     </g>
//   )
// };

interface LegendProps {
    colors: (i: string) => any
    labels: string[]
    outerRadius: number
    width: number
    height: number
}

const Legend = ({
    colors,
    labels,
    outerRadius,
    width,
    height
}: LegendProps) => {
    return (
        <g
            transform={`translate(${width / 2}, ${
                outerRadius * HEIGHT_CONST * 1.5
            })`}
        >
            <text
                x={0}
                y={100}
                fill={"black"}
                textAnchor="start"
                style={{ alignmentBaseline: "middle", fontWeight: "bold" }}
            >
                Legenda:
            </text>
            {labels.map((label, i) => {
                return (
                    <Fragment key={i}>
                        <circle
                            cx={90}
                            cy={100 + i * 25}
                            fill={colors(i.toString())}
                            r={7}
                        ></circle>
                        <text
                            x={110}
                            y={100 + i * 25}
                            fill={"black"}
                            textAnchor="start"
                            style={{ alignmentBaseline: "middle" }}
                        >
                            {label}{" "}
                        </text>
                    </Fragment>
                )
            })}
        </g>
    )
}
interface PieChartProps {
    data: any
    width: number
    height: number
    outerRadius: number
    innerRadius: number
}

const PieChart = (props: PieChartProps) => {
    // const createPie = d3
    //   .pie()
    //   .value(d => d)
    //   .sort(null);
    // const createArc = d3
    //   .arc()
    //   .innerRadius(props.innerRadius)
    //   .outerRadius(props.outerRadius);

    const colors = d3.scaleOrdinal(["#00008B", "#FF0000", "#008000"])
    const labelColors = d3.scaleOrdinal(["#00008B", "#008000", "#FF0000"])
    //const format = d3.format(".2f");

    const width = props.width * 2

    const aspect = width / props.height
    const adjustedHeight = Math.ceil(width / aspect)

    const {
        totalePersoneFisiche,
        totaleSocCapitaliEntiNonComm,
        totaleSocietaPersone,
        totale
    } = props.data
    //const { totalePersoneFisiche, totaleSocCapitaliEntiNonComm, totaleSocietaPersone, totale } = props.data;
    // console.log(props.data);
    //console.log(totale.numeroPosizioni.replace(/\./g, ''));

    const totalePosizioni = parseInt(totale.numeroPosizioni.replace(/\./g, ""))
    const numPersoneFisiche = parseInt(
        totalePersoneFisiche?.numeroPosizioni?.replace(/\./g, "")
    )
    const numSocCapitali = totaleSocCapitaliEntiNonComm!= null ? parseInt(
        totaleSocCapitaliEntiNonComm?.numeroPosizioni?.replace(/\./g, "")
    ) : 0;
    const numSocPersone = parseInt(
        totaleSocietaPersone?.numeroPosizioni?.replace(/\./g, "")
    )
   
    
    const percPersoneFisiche = (numPersoneFisiche * 100) / totalePosizioni
    const percSocCapitali = (numSocCapitali * 100) / totalePosizioni
    const percSocPersone = (numSocPersone * 100) / totalePosizioni
    //console.log(percPersoneFisiche)
    const datiNazionali = [
        percPersoneFisiche.toFixed(2),
        percSocPersone.toFixed(2),
        percSocCapitali.toFixed(2)
    ]
    //const data = createPie(datiNazionali);

    const addSizeExplorer = usingExplorer() ? 25 : 0

    const labels = [
        "Persone Fisiche",
        "Società di Capitali e Enti non Commerciali",
        "Società di Persone"
    ]

    useEffect(() => {
        Donut3D.draw(
            "quotesDonut",
            datiNazionali
                .map((d, i) => ({
                    label: `${d}%`,
                    value: d,
                    color: colors(i.toString())
                }))
                .reverse(),
            0,
            0,
            160,
            130,
            30,
            0
        )
        return () => {}
    }, [datiNazionali, colors])

    return (
        isNaN(numPersoneFisiche) || isNaN(numSocCapitali) || isNaN(numSocPersone) || isNaN(totalePosizioni) 
        ?<svg
        overflow="hidden"
        preserveAspectRatio="xMinYMin slice"
        viewBox={`0 0 ${width} ${adjustedHeight}`}
        id="pie_chart"
    >
        <text
            fontWeight={"bold"}
            fontSize={28}
            transform={`translate(${props.width - addSizeExplorer} ${adjustedHeight / 2})`}
            fill="black"
            textAnchor="middle"
        >
            Grafico Non Disponibile
        </text>
       
        
    </svg>
        :
        <>
            <svg
                overflow="hidden"
                preserveAspectRatio="xMinYMin slice"
                viewBox={`0 0 ${width} ${adjustedHeight}`}
                id="pie_chart"
            >
                <text
                    fontWeight={"bold"}
                    fontSize={24}
                    transform={`translate(${props.width - addSizeExplorer} 30)`}
                    fill="black"
                    textAnchor="middle"
                >
                    Posizioni per Natura Giuridica
                </text>
                <g
                    id={"quotesDonut"}
                    transform={`translate(${props.width - addSizeExplorer} ${
                        props.outerRadius * HEIGHT_CONST
                    })`}
                >
                    {/* {data.map((d, i) => (
            <Arc
              key={i}
              data={d}
              index={i}
              createArc={createArc}
              colors={colors}
              format={format} />
          ))} */}
                </g>
                <Legend
                    colors={labelColors}
                    labels={labels}
                    outerRadius={props.outerRadius}
                    width={props.width}
                    height={adjustedHeight}
                />
                ;
            </svg>
        </>
    )
}

export default PieChart
